var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/HighlightOff.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HighlightOff = ({
  color = '#353B60',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("path", {
    d: "M12 4.10547C7.576 4.10547 4 7.68147 4 12.1055C4 16.5295 7.576 20.1055 12 20.1055C16.424 20.1055 20 16.5295 20 12.1055C20 7.68147 16.424 4.10547 12 4.10547Z",
    fill: color
  }), /*#__PURE__*/_jsx("path", {
    d: "M13.8897 8.80616L11.9997 10.6962L10.1097 8.80616C9.9229 8.6189 9.66924 8.51367 9.40473 8.51367C9.14021 8.51367 8.88656 8.6189 8.69973 8.80616C8.30973 9.19616 8.30973 9.82616 8.69973 10.2162L10.5897 12.1062L8.69973 13.9962C8.30973 14.3862 8.30973 15.0162 8.69973 15.4062C9.08973 15.7962 9.71973 15.7962 10.1097 15.4062L11.9997 13.5162L13.8897 15.4062C14.2797 15.7962 14.9097 15.7962 15.2997 15.4062C15.6897 15.0162 15.6897 14.3862 15.2997 13.9962L13.4097 12.1062L15.2997 10.2162C15.6897 9.82616 15.6897 9.19616 15.2997 8.80616C14.9097 8.42616 14.2697 8.42616 13.8897 8.80616Z",
    fill: "white"
  })]
});